export default {"src":"/_next/static/media/caret_up.2b2a874a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};